import { Action } from '@ngrx/store';
import { Product } from '../../product.model';

export enum ActionType {

  ADD_PRODUCT = 'ADD_PRODUCT',
  ADD_PRODUCT_SUCCESS = 'ADD_PRODUCT SUCCESS',
  ADD_PRODUCT_FAILED = 'ADD_PRODUCT FAILED',
  DELETE_PRODUCT = 'DELETE_PRODUCT',
  DELETE_PRODUCT_SUCCESS = 'DELETE_PRODUCT SUCCESS',
  DELETE_PRODUCT_FAILED = 'DELETE_PRODUCT FAILED',
  FETCH_PRODUCTS = 'FETCH PRODUCTS',
  FETCH_PRODUCTS_SUCCESS = 'FETCH PRODUCTS SUCCESS',
  FETCH_PRODUCTS_FAILED = 'FETCH PRODUCTS FAILED',
  UPDATE_PRODUCT = 'UPDATE PRODUCT',
  UPDATE_PRODUCT_SUCCESS = 'UPDATE PRODUCT SUCCESS',
  UPDATE_PRODUCT_FAILED = 'UPDATE PRODUCT FAILED',
  FETCH_PRODUCTS_BY_COMPANYID = 'FETCH PRODUCTS BY COMPANYID',
  FETCH_PRODUCTS_BY_COMPANYID_SUCCESS = 'FETCH PRODUCTS BY COMPANYID SUCCESS',
  FETCH_PRODUCTS_BY_COMPANYID_FAILED = 'FETCH PRODUCTS BY COMPANYID FAILED',
  DESTROY_PRODUCT = 'DESTROY_PRODUCT',
  DESTROY_PRODUCT_SUCCESS = 'DESTROY_PRODUCT SUCCESS',
  DESTROY_PRODUCT_FAILED = 'DESTROY_PRODUCT FAILED',
  FETCH_PRODUCTS_BY_COMPANYIDSITEID = 'FETCH PRODUCTS BY COMPANYIDSITEID',
  FETCH_PRODUCTS_BY_COMPANYIDSITEID_SUCCESS = 'FETCH PRODUCTS BY COMPANYIDSITEID SUCCESS',
  FETCH_PRODUCTS_BY_COMPANYIDSITEID_FAILED = 'FETCH PRODUCTS BY COMPANYIDSITEID FAILED',
}

export class DestroyProduct implements Action {
  readonly type = ActionType.DELETE_PRODUCT;

  constructor(public id: string) { }
}

export class DestroyProductSuccess implements Action {
  readonly type = ActionType.DELETE_PRODUCT_SUCCESS;

  constructor(public id: string) { }
}

export class DestroyProductFailed implements Action {
  readonly type = ActionType.DELETE_PRODUCT_FAILED;

  constructor() { }
}

export class FetchProductsByCompanyIdSiteId implements Action {
  readonly type = ActionType.FETCH_PRODUCTS_BY_COMPANYIDSITEID;
  constructor(public companyId: string, public siteId: string) { }
}

export class FetchProductsByCompanyIdSiteIdSuccess implements Action {
  readonly type = ActionType.FETCH_PRODUCTS_BY_COMPANYIDSITEID_SUCCESS;
  constructor(public products: Product[]) { }
}

export class FetchProductsByCompanyIdSiteIdFailed implements Action {
  readonly type = ActionType.FETCH_PRODUCTS_BY_COMPANYIDSITEID_FAILED;
  constructor(public error: any) { }
}






export class FetchProductsByCompanyId implements Action {
  readonly type = ActionType.FETCH_PRODUCTS_BY_COMPANYID;
  constructor(public companyId: string) { }
}

export class FetchProductsByCompanyIdSuccess implements Action {
  readonly type = ActionType.FETCH_PRODUCTS_BY_COMPANYID_SUCCESS;
  constructor(public products: Product[]) { }
}

export class FetchProductsByCompanyIdFailed implements Action {
  readonly type = ActionType.FETCH_PRODUCTS_BY_COMPANYID_FAILED;
  constructor(public error: any) { }
}

export class FetchProducts implements Action {
  readonly type = ActionType.FETCH_PRODUCTS;
  constructor() { }
}

export class FetchProductsSuccess implements Action {
  readonly type = ActionType.FETCH_PRODUCTS_SUCCESS;
  constructor(public products: Product[]) { }
}

export class FetchProductsFailed implements Action {
  readonly type = ActionType.FETCH_PRODUCTS_FAILED;
  constructor(public error: any) { }
}

export class AddProduct implements Action {
  readonly type = ActionType.ADD_PRODUCT;

  constructor(public product: Product) { console.log('product', product); }
}

export class AddProductSuccess implements Action {
  readonly type = ActionType.ADD_PRODUCT_SUCCESS;

  constructor(public product: Product) { }
}

export class AddProductFailed implements Action {
  readonly type = ActionType.ADD_PRODUCT_FAILED;

  constructor() { }
}

export class DeleteProduct implements Action {
  readonly type = ActionType.DELETE_PRODUCT;

  constructor(public id: string) { }
}

export class DeleteProductSuccess implements Action {
  readonly type = ActionType.DELETE_PRODUCT_SUCCESS;

  constructor(public id: string) { }
}

export class DeleteProductFailed implements Action {
  readonly type = ActionType.DELETE_PRODUCT_FAILED;

  constructor() { }
}

export class UpdateProduct implements Action {
  readonly type = ActionType.UPDATE_PRODUCT;

  constructor(public product: Product) { }
}

export class UpdateProductSuccess implements Action {
  readonly type = ActionType.UPDATE_PRODUCT_SUCCESS;

  constructor(
    public id: string,
    public changes: Partial<Product>,
  ) { console.log('changes', changes); }
}

export class UpdateProductFailed implements Action {
  readonly type = ActionType.UPDATE_PRODUCT_FAILED;

  constructor() { }
}

export type ProductActions =
  AddProduct | AddProductFailed | AddProductSuccess |
  UpdateProduct | UpdateProductSuccess | UpdateProductFailed |
  DeleteProduct | DeleteProductSuccess | DeleteProductFailed |
  FetchProducts | FetchProductsSuccess | FetchProductsFailed |
  FetchProductsByCompanyId | FetchProductsByCompanyIdSuccess | FetchProductsByCompanyIdFailed |
  FetchProductsByCompanyIdSiteId | FetchProductsByCompanyIdSiteIdSuccess | FetchProductsByCompanyIdSiteIdFailed |
  DestroyProduct | DestroyProductSuccess | DestroyProductFailed
  ;



